/* WOKORA v2.4 P3.2 — approved B2B case tier + checkout discount bridge, event-driven runtime */
(() => {
  'use strict';

  if (window.__wokoraBulkPricingP32) return;
  window.__wokoraBulkPricingP32 = true;

  const MIN_CASES = 10;
  const DISCOUNT_EUR = 2;

  // Hidden redeem codes stay restricted to the approved-business customer segment.
  // Variant batches and discount behavior are unchanged from the previous runtime.
  const BATCHES = [
    { min: 62435065987459, max: 62435180904835, code: 'WZK10-1EWMIPO18CLT' },
    { min: 62435180970371, max: 62435234251139, code: 'WZK10-LRE41M8XUEGB' },
    { min: 62435234316675, max: 62439718191491, code: 'WZK10-AC0VWSOCDA9G' },
    { min: 62439718257027, max: 62439868662147, code: 'WZK10-SA0LIOXHBQY9' }
  ];

  const businessUrl = document.body?.dataset.businessPageUrl || '/pages/zakelijk-account';
  const isApproved = () => document.body?.dataset.businessStatus === 'approved';
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  function batchForVariant(id) {
    const numericId = Number(id || 0);
    return BATCHES.find((batch) => numericId >= batch.min && numericId <= batch.max) || null;
  }

  function isCaseCartItem(item) {
    const sku = String(item?.sku || '');
    const title = String(item?.variant_title || item?.variant_options?.join(' ') || '');
    return /-CASE$/i.test(sku) || /per\s*case/i.test(title);
  }

  function eligibleCaseItems(cart) {
    return (cart?.items || []).filter((item) => isCaseCartItem(item) && batchForVariant(item.variant_id));
  }

  function caseQuantity(cart) {
    return eligibleCaseItems(cart).reduce((sum, item) => sum + Math.max(0, Number(item.quantity || 0)), 0);
  }

  function discountCodesForCart(cart) {
    const codes = new Set();
    eligibleCaseItems(cart).forEach((item) => {
      const batch = batchForVariant(item.variant_id);
      if (batch) codes.add(batch.code);
    });
    return Array.from(codes);
  }

  function rewriteLegacyBusinessLinks() {
    document
      .querySelectorAll('a[href="/pages/zakelijk-bestellen"],a[href="#wokora-zakelijk"],a[href="#zakelijk-aanvragen"]')
      .forEach((link) => link.setAttribute('href', businessUrl));
  }

  function tierMessage(cases) {
    const remaining = Math.max(0, MIN_CASES - cases);
    if (!isApproved()) {
      return remaining > 0
        ? `Nog ${remaining} dozen tot de dozenstaffel. Na goedkeuring geldt vanaf ${MIN_CASES} dozen €${DISCOUNT_EUR} voordeel per in aanmerking komende doos.`
        : `Aantal bereikt. Log in met een goedgekeurd zakelijk account om €${DISCOUNT_EUR} voordeel per in aanmerking komende doos bij checkout te ontvangen.`;
    }
    if (remaining > 0) return `Nog ${remaining} dozen tot de zakelijke staffel. Per stuk telt niet mee.`;
    const saving = cases * DISCOUNT_EUR;
    return `Staffel actief: €${DISCOUNT_EUR} voordeel per in aanmerking komende doos wordt bij checkout toegepast. Verwacht voordeel bij ${cases} dozen: €${saving}.`;
  }

  function renderTierCard(card, cases) {
    const pct = clamp((cases / MIN_CASES) * 100, 0, 100);
    card.dataset.w24Signature = `${cases}|${isApproved() ? '1' : '0'}`;
    card.innerHTML = `
      <div class="w24-cart-tier__head">
        <strong>Zakelijke dozenstaffel</strong>
        <span>${cases} / ${MIN_CASES} dozen</span>
      </div>
      <div class="w24-cart-tier__bar"><i style="width:${pct}%"></i></div>
      <p>${tierMessage(cases)}</p>
      ${isApproved() ? '' : `<a href="${businessUrl}">Zakelijk account aanvragen →</a>`}
    `;
  }

  function cartTierCard() {
    const drawer = document.querySelector('[data-cart-drawer]');
    const foot = drawer?.querySelector('.w19-cart-drawer__foot');
    if (!drawer || !foot) return;

    const caseRows = Array.from(drawer.querySelectorAll('.w19-drawer-item')).filter((row) =>
      row.querySelector('.w19-pack-pill--case')
    );
    const cases = caseRows.reduce(
      (sum, row) => sum + Math.max(0, Number(row.querySelector('[data-cart-line-qty]')?.value || 0)),
      0
    );

    let card = foot.querySelector('[data-w24-cart-tier]');
    if (!caseRows.length) {
      card?.remove();
      return;
    }

    const signature = `${cases}|${isApproved() ? '1' : '0'}`;
    if (card?.dataset.w24Signature === signature) return;

    if (!card) {
      card = document.createElement('div');
      card.className = 'w24-cart-tier';
      card.dataset.w24CartTier = '';
      const totals = foot.querySelector('.w19-drawer-totals');
      if (totals) totals.insertAdjacentElement('beforebegin', card);
      else foot.prepend(card);
    }
    renderTierCard(card, cases);
  }

  function mainCartTierCards() {
    const page = document.querySelector('[data-w19-cart-flow]');
    if (!page) return;

    const caseRows = Array.from(page.querySelectorAll('.w19-cart-item')).filter((row) =>
      row.querySelector('.w19-pack-pill--case')
    );
    if (!caseRows.length) {
      page.querySelectorAll('[data-w24-main-tier]').forEach((card) => card.remove());
      return;
    }

    const cases = caseRows.reduce(
      (sum, row) => sum + Math.max(0, Number(row.querySelector('[data-main-cart-qty]')?.value || 0)),
      0
    );

    const host = page.querySelector('[data-w19-step-panel="3"] .w19-flow-card--soft');
    if (!host) return;
    const before = page.querySelector('[data-w19-step-panel="3"] .w19-flow-secure');
    let card = host.querySelector('[data-w24-main-tier="0"]');
    const signature = `${cases}|${isApproved() ? '1' : '0'}`;

    if (!card) {
      card = document.createElement('div');
      card.className = 'w24-cart-tier';
      card.dataset.w24MainTier = '0';
      if (before) before.insertAdjacentElement('beforebegin', card);
      else host.append(card);
    }
    if (card.dataset.w24Signature !== signature) renderTierCard(card, cases);
  }

  function clarifyBusinessPage() {
    const page = document.querySelector('.business-v233');
    if (!page || page.dataset.w24Clarified === 'true') return;
    page.dataset.w24Clarified = 'true';

    const future = page.querySelector('.business-v233__benefit--future');
    if (future) {
      const h3 = future.querySelector('h3');
      const p = future.querySelector('p');
      if (h3) h3.textContent = '€2 dozenstaffel vanaf 10 dozen';
      if (p) p.textContent = 'Per stuk blijft de normale prijs. Voor goedgekeurde zakelijke klanten geldt vanaf 10 in aanmerking komende dozen €2 voordeel per doos. Verschillende Per Case-producten mogen samen de grens van 10 vormen.';
    }

    const truth = page.querySelector('.business-v233__truth');
    if (truth) {
      const strong = truth.querySelector('strong');
      const p = truth.querySelector('p');
      if (strong) strong.textContent = 'Geen algemene korting op losse stuks.';
      if (p) p.textContent = 'WOKORA houdt de normale stukprijs aan. De huidige zakelijke staffel is €2 voordeel per in aanmerking komende Per Case-doos vanaf in totaal 10 dozen en is alleen beschikbaar voor goedgekeurde zakelijke accounts.';
    }
  }

  function cartRoot() {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  }

  async function fetchCart() {
    const response = await fetch(`${cartRoot()}cart.js`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    return response.json();
  }

  function hasComplexLines(cart) {
    return (cart?.items || []).some((item) => {
      if (item.selling_plan_allocation) return true;
      const properties = item.properties && typeof item.properties === 'object' ? item.properties : {};
      return Object.keys(properties).some((key) => properties[key] !== null && properties[key] !== '');
    });
  }

  function buildDiscountCheckoutUrl(cart, form) {
    const caseCount = caseQuantity(cart);
    if (caseCount < MIN_CASES) return null;
    if (hasComplexLines(cart)) return null;

    const codes = discountCodesForCart(cart);
    if (!codes.length) return null;

    const quantities = new Map();
    (cart.items || []).forEach((item) => {
      const id = Number(item.variant_id || 0);
      const qty = Math.max(0, Number(item.quantity || 0));
      if (!id || !qty) return;
      quantities.set(id, (quantities.get(id) || 0) + qty);
    });
    if (!quantities.size) return null;

    const lineSpec = Array.from(quantities.entries())
      .map(([id, qty]) => `${id}:${qty}`)
      .join(',');

    const url = new URL(`${cartRoot()}cart/${lineSpec}`, window.location.origin);
    url.searchParams.set('discount', codes.join(','));

    const noteField = form?.querySelector('textarea[name="note"]');
    const note = String(noteField?.value ?? cart.note ?? '').trim();
    if (note) url.searchParams.set('note', note);

    const attributes = { ...(cart.attributes || {}) };
    form?.querySelectorAll('[name^="attributes["]').forEach((field) => {
      const match = field.name.match(/^attributes\[(.+)\]$/);
      if (match) attributes[match[1]] = field.value || '';
    });
    Object.entries(attributes).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value) !== '') {
        url.searchParams.set(`attributes[${key}]`, String(value));
      }
    });

    const locale = String(document.documentElement.lang || '').split('-')[0];
    if (locale) url.searchParams.set('locale', locale);
    url.searchParams.set('ref', 'wokora-zakelijk-dozenstaffel');
    return url.toString();
  }

  let bypassCheckoutSubmit = false;
  let checkoutInFlight = false;

  function mountCheckoutBridge() {
    if (document.documentElement.dataset.w24CheckoutBridge === 'true') return;
    document.documentElement.dataset.w24CheckoutBridge = 'true';

    document.addEventListener('submit', async (event) => {
      const form = event.target?.closest?.('[data-cart-main-form]');
      const submitter = event.submitter;
      if (!form || !submitter?.matches?.('[data-w19-final-checkout], [name="checkout"]')) return;

      if (bypassCheckoutSubmit) {
        bypassCheckoutSubmit = false;
        return;
      }
      if (!isApproved() || checkoutInFlight) return;

      event.preventDefault();
      checkoutInFlight = true;

      const originalText = submitter.textContent;
      submitter.disabled = true;
      submitter.textContent = 'Zakelijke staffel controleren…';

      const continueNormally = () => {
        checkoutInFlight = false;
        submitter.disabled = false;
        submitter.textContent = originalText;
        bypassCheckoutSubmit = true;
        form.requestSubmit(submitter);
      };

      try {
        const cart = await fetchCart();
        const url = buildDiscountCheckoutUrl(cart, form);
        if (!url) {
          continueNormally();
          return;
        }
        window.location.assign(url);
      } catch (error) {
        console.warn('[WOKORA v2.4] Staffelcontrole overgeslagen:', error);
        continueNormally();
      }
    }, true);
  }

  let queued = false;
  const refresh = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      rewriteLegacyBusinessLinks();
      cartTierCard();
      mainCartTierCards();
      clarifyBusinessPage();
      mountCheckoutBridge();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();

  document.addEventListener('wokora:cart-updated', refresh);
  document.addEventListener('wokora:cart-drawer-refreshed', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
